export const VERSION = '4.0.3';
export const ID = '1874642be3f8ba11bf7b39ca94d9a36b32a6e8c0';
export const DATE = '2022-05-16T23:29:47.258Z';